import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  orderId: z.string(),
  waLink: z.string(),
});

export const Route = createFileRoute("/order-confirmation")({
  validateSearch: searchSchema,
  component: lazyRouteComponent(() => import("./order-confirmation.lazy")),
});
